(() => {
  const configNode = document.getElementById('veiro-invoice-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  if (!config.enabled) return;
  const root = config.root.replace(/\/?$/, '/');
  const current = new URL(location.href);
  const entry = new URL(config.entry, location.origin);
  const active = (current.pathname === entry.pathname && [...entry.searchParams].every(([key,value])=>current.searchParams.get(key)===value)) || current.searchParams.get('invoice') === config.key;
  const keys = ['company','addressee','person','email','address','department','po','item_label','notes'].map(k => 'invoice_' + k);
  const required = keys.slice(0,5);
  let ready = false;
  let busy = false;
  let pending = Promise.resolve();
  const form = document.getElementById('veiro-invoice-form');
  const status = document.createElement('p');
  status.className = 'veiro-invoice-status';
  status.setAttribute('role','status');
  status.hidden = true;
  document.body.append(status);
  const notify = text => { status.textContent = text; status.hidden = !text; };
  const marked = value => {
    const url = new URL(value, location.origin);
    if (url.origin === location.origin) url.searchParams.set('invoice',config.key);
    return url.href;
  };
  async function request(path, data) {
    const response = await fetch(root + path, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)});
    if (!response.ok) throw new Error('Request failed');
    return response.json();
  }
  async function reset() {
    const attributes = Object.fromEntries(keys.map(key=>[key,'']));
    attributes.invoice_access = 'false';
    const cart = await request('cart/update.js',{attributes});
    if (cart.attributes?.invoice_access !== 'false' || keys.some(key=>cart.attributes?.[key])) throw new Error('Reset failed');
  }
  function showPanel(name) {
    document.querySelectorAll('[data-invoice-panel]').forEach(panel=>{panel.hidden=panel.dataset.invoicePanel!==name;});
    document.querySelector(`[data-invoice-panel="${name}"] h1`)?.focus();
  }
  const fail = () => { ready=false; notify(config.error); };
  function initialize() {
    ready=false;
    pending=pending.catch(()=>{}).then(()=>active ? undefined : reset());
    pending.then(()=>{if(form&&!active){location.assign(root);return;}ready=true;document.querySelectorAll('[data-invoice-action]').forEach(button=>{button.disabled=false;});notify('');}).catch(fail);
    if (form) showPanel('entry');
  }
  if (active) {
    document.documentElement.classList.add('veiro-invoice-active');
    const banner=document.createElement('div');
    banner.className='veiro-invoice-banner';
    banner.append(document.createTextNode(config.banner+' '));
    const exit=document.createElement('a');
    exit.href=root; exit.textContent=config.exit; exit.dataset.invoiceExit='true';
    banner.append(exit); document.body.prepend(banner);
    document.querySelectorAll('[data-product-url]').forEach(button=>{button.dataset.productUrl=marked(button.dataset.productUrl);});
    document.querySelectorAll('a[href]').forEach(link=>{
      const url=new URL(link.href,location.origin);
      if (link.dataset.invoiceExit || url.origin!==location.origin || !/^https?:$/.test(url.protocol)) return;
      if (url.pathname.startsWith(root+'checkouts') || url.pathname===root+'checkout') link.href=entry.href;
      else if (url.pathname===root || url.pathname.startsWith(root+'products/') || url.pathname.startsWith(root+'collections/') || url.pathname.startsWith(root+'pages/') || url.pathname.startsWith(root+'policies/') || url.pathname.startsWith(root+'blogs/') || url.pathname===root+'search' || url.pathname===root+'cart') link.href=marked(url.href);
    });
  }
  document.addEventListener('click',async event=>{
    const link=event.target.closest?.('a[href]');
    if(!active || !link || link.dataset.invoiceExit) return;
    const url=new URL(link.href,location.origin);
    if(url.origin!==location.origin || url.pathname!==root+'cart/change') return;
    event.preventDefault();
    if(busy) return;
    busy=true;
    try {
      await pending;
      if(!ready) throw new Error('Not ready');
      const result=await request('cart/change.js',{id:url.searchParams.get('id'),quantity:0});
      if(!Array.isArray(result.items)) throw new Error('Cart response invalid');
      location.assign(marked(root+'cart'));
    } catch {fail();} finally {busy=false;}
  },true);
  document.addEventListener('submit',async event=>{
    const target=event.target;
    if (!(target instanceof HTMLFormElement) || target===form) return;
    const action=new URL(target.action,location.origin);
    const isProduct=action.pathname===root+'cart/add';
    const isCart=action.pathname===root+'cart';
    if (!isCart && !(active && isProduct)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if(busy) return;
    busy=true;
    try {
      await pending;
      if(!ready) throw new Error('Not ready');
      const data=new FormData(target);
      if(isProduct) {
        if(!target.reportValidity()) return;
        const response=await fetch(root+'cart/add.js',{method:'POST',body:data});
        if(!response.ok) throw new Error('Cannot add');
        location.assign(marked(root+'cart')); return;
      }
      const updates=data.getAll('updates[]').map(value=>Number(value));
      if(updates.some(value=>!Number.isInteger(value)||value<0)) throw new Error('Invalid quantity');
      const cart=await request('cart/update.js',{updates});
      if(event.submitter?.name==='checkout') {
        if(!cart.item_count) { location.assign(active?marked(root+'cart'):root+'cart'); return; }
        if(active) location.assign(entry.href);
        else { await reset(); location.assign(root+'checkout'); }
      } else location.assign(active?marked(root+'cart'):root+'cart');
    } catch { fail(); } finally { busy=false; }
  },true);
  form?.addEventListener('input',event=>event.target.setCustomValidity?.(''));
  form?.addEventListener('submit',event=>{
    event.preventDefault();
    if(!active || !ready) return;
    for(const key of keys) {
      const field=form.elements.namedItem(key);
      field.value=field.value.trim();
      field.setCustomValidity(required.includes(key)&&!field.value?config.required:'');
    }
    if(!form.reportValidity()) return;
    const list=document.getElementById('veiro-invoice-values'); list.replaceChildren();
    for(const key of keys) {
      const field=form.elements.namedItem(key);
      if(!field.value) continue;
      const term=document.createElement('dt'), value=document.createElement('dd');
      term.textContent=field.dataset.label; value.textContent=field.value;
      list.append(term,value);
    }
    showPanel('confirm');
  });
  document.getElementById('veiro-invoice-edit')?.addEventListener('click',()=>showPanel('entry'));
  document.getElementById('veiro-invoice-checkout')?.addEventListener('click',async()=>{
    if(busy) return;
    busy=true;
    try {
      await pending;
      if(!active || !ready || !form.reportValidity()) throw new Error('Not ready');
      const attributes=Object.fromEntries(keys.map(key=>[key,form.elements.namedItem(key).value.trim()]));
      if(required.some(key=>!attributes[key])) throw new Error('Missing field');
      attributes.invoice_access='true';
      const cart=await request('cart/update.js',{attributes});
      if(!cart.item_count) { await reset(); notify(config.empty); showPanel('entry'); return; }
      if(Object.entries(attributes).some(([key,value])=>(cart.attributes?.[key]||'')!==value)) throw new Error('Save failed');
      location.assign(root+'checkout?skip_shop_pay=true');
    } catch { try {await reset();} catch {} fail(); } finally {busy=false;}
  });
  window.addEventListener('pageshow',initialize);
})();
